module.exports = __webpack_public_path__ + "static/media/SnakeGame.41d401ea.WebP";